/*
 * Copyright (c) Nexign, JSC, 2021-2022.
 */
/**
 *
 *
 * @author Yakov Gushchin
 * @version 1.19.0
 * @since 1.15.0
 */

import { SagaIterator } from 'redux-saga';
import { all, put, take, takeEvery } from 'redux-saga/effects';

import {
    onboardingInitStartAction,
    onboardingPageReadyForStartAction,
} from '../../modules/onboarding/onboardingActions';
import { ONBOARDING_INIT_SUCCESS } from '../../modules/onboarding/onboardingConstants';
import { EOnboardingPage } from '../../modules/onboarding/types/onboardingTypes';
import { tableApi } from '../../modules/table/store';

export function* pageSubscriberMobileStartOnboardingSaga(): SagaIterator {
    yield put(onboardingInitStartAction({ page: EOnboardingPage.subscriberMobile }));
    yield take(ONBOARDING_INIT_SUCCESS);

    yield put(onboardingPageReadyForStartAction());
}

export function* saga(): SagaIterator {
    yield all([
        takeEvery(tableApi.endpoints.getTableMeta.matchFulfilled, pageSubscriberMobileStartOnboardingSaga),
    ]);
}
